﻿'use strict';

angular.module('ntmApp').factory('AttendanceProjectionsFilter', ['MultiSelectFilter', 'SimpleFilter', 'RadioButtonChoiceFilter', '$filter', 'Constants',
    function (MultiSelectFilter, SimpleFilter, RadioButtonChoiceFilter, $filter, Constants) {

    function AttendanceProjectionsFilter() {

        var self = this;

        self.RoleFilter = new MultiSelectFilter(Constants.DropDownBlankLabels.NoRole);
        self.HasPTOFilter = new RadioButtonChoiceFilter(function (item) {
            
            if (item === 'yes') {
                return 'Has PTO this week';
            }

            if (item === 'no') {
                return 'Does not have PTO this week';
            }

            return '';
        });

        self.getfilters = function () {
            return [
                self.RoleFilter,
                self.HasPTOFilter
            ];
        };

        self.getAppliedFilters = function () {
            return self.getfilters().filter(function (filter) {
                return filter.isDefined();
            });
        };

        self.applied = function () {
            var filters = self.getAppliedFilters();

            if (filters) {
                return filters.length > 0;
            }

            return false;
        };

        self.isPartlyDefined = function () {
            return self.getfilters().some(function(filter) { return filter.isPartlyDefined(); });
        };

        self.clearAllFilters = function () {
            self.RoleFilter.clear();
            self.HasPTOFilter.clear();
        };

        self.filterItems = function (records) {

            var result = [];

            if (records) {

                var filteredByStaffName = $filter('filter')(records, { staffName: self.staffName });

                filteredByStaffName.forEach(function (record) {

                    if (self.RoleFilter.isDefined() && !self.RoleFilter.selectedItems.some(function (role) {
                        return (role.value === record.role) || (!role.id && !record.role);
                    })) {
                        return;
                    }

                    if (self.HasPTOFilter.filterItem) {
                        
                        if (self.HasPTOFilter.filterItem === 'yes' && !hasPTO(record)) {
                            return;
                        }

                        if (self.HasPTOFilter.filterItem === 'no' && hasPTO(record)) {
                            return;
                        }
                    }

                    result.push(record);
                });
            }

            return result;
        };

        function hasPTO(attendanceRecord) {

            if (attendanceRecord.items) {
                return attendanceRecord.items.some(function (item) {
                    return item.attendanceState === 'pto';
                });
            }

            return false;
        }
    }

    return (AttendanceProjectionsFilter);
}]);